import { render, staticRenderFns } from "./FormDetailActions.vue?vue&type=template&id=4da33c78&scoped=true&"
import script from "./FormDetailActions.vue?vue&type=script&lang=js&"
export * from "./FormDetailActions.vue?vue&type=script&lang=js&"
import style0 from "./FormDetailActions.vue?vue&type=style&index=0&id=4da33c78&prod&scoped=true&lang=scss&"
import style1 from "./FormDetailActions.vue?vue&type=style&index=1&id=4da33c78&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da33c78",
  null
  
)

export default component.exports